import { CsvProvider } from "./context/CsvContext";
import { Certification } from "./pages/Certification";

function App() {
  return (
    <CsvProvider>
      <Certification />
    </CsvProvider>
  );
}

export default App;
